import { Document, UploadedDocument } from "@/shared/domains";
import { parseResponseData, privateAPI } from "@/shared/lib";
import type { ProviderFolder } from "@/shared/models/legacy-types";

const DOMAIN = "coaching-hub";
const API_PATH = "/documents/coaching-hub";

interface GetCoachingHubDocumentsParams {
  providerFolder: ProviderFolder;
  limit?: number;
}

export const getProviderDocumentsQuery = (
  params: GetCoachingHubDocumentsParams,
) => ({
  queryKey: [DOMAIN, "getProviderDocumentsQuery", params],
  queryFn: async () => {
    const response = await privateAPI.get(
      API_PATH,
      // TODO: BE - This should be called providerFolder instead of coachingType
      // because not all providerFolders are coachingTypes
      { params: { coachingType: params.providerFolder, limit: params.limit } },
    );

    return parseResponseData(response, Document.array());
  },
});

interface GetDocumentFromProviderParams {
  providerFolder: ProviderFolder;
  documentId?: string | null;
}

export const getDocumentFromProviderQuery = ({
  providerFolder: coachingType,
  documentId,
}: GetDocumentFromProviderParams) => ({
  enabled: !!documentId,
  queryKey: [DOMAIN, "getDocumentFromProviderQuery", documentId],
  queryFn: async () => {
    const response = await privateAPI.get(
      `/documents/from-provider/${documentId}`,
      { params: { coachingType } },
    );

    return parseResponseData(response, UploadedDocument);
  },
});
